/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AdminApiInContract,
  AdminApiOutContract,
  AdminPermissionsApiInContract,
  AdminPermissionsApiOutContract,
  AvailableAdminPermissionsApiOutContract,
  ErrorApiOutContract,
  ErrorDescription,
  ImageApiOutContract,
  PutAdminsUserIdProfileimageBody
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postAdmins = (
    adminApiInContract: AdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminApiInContract, signal
    },
      options);
    }
  


export const getPostAdminsMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdmins>>, TError,{data: AdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdmins>>, TError,{data: AdminApiInContract}, TContext> => {

const mutationKey = ['postAdmins'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdmins>>, {data: AdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAdmins(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdmins>>>
    export type PostAdminsMutationBody = AdminApiInContract
    export type PostAdminsMutationError = ErrorDescription | void | ErrorApiOutContract

    export const usePostAdmins = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdmins>>, TError,{data: AdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdmins>>,
        TError,
        {data: AdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAdminsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAdminsUserId = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminsUserIdInfiniteQueryKey = (userId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/${userId}`
    ] as const;
    }

export const getGetAdminsUserIdQueryKey = (userId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/${userId}`
    ] as const;
    }

    
export const getGetAdminsUserIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdInfiniteQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserId>>> = ({ signal }) => getAdminsUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserId>>>
export type GetAdminsUserIdInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminsUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminsUserIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsUserIdInfiniteQueryOptions(userId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserId>>> = ({ signal }) => getAdminsUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserId>>>
export type GetAdminsUserIdQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserId<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserId<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserId<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminsUserId<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminsUserIdQuery = async <TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsUserIdQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsUserIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserId>>> = ({ signal }) => getAdminsUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserId>>>
export type GetAdminsUserIdSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdSuspense<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdSuspense<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdSuspense<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminsUserIdSuspense<TData = Awaited<ReturnType<typeof getAdminsUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsUserIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdInfiniteQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserId>>> = ({ signal }) => getAdminsUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserId>>>
export type GetAdminsUserIdSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminsUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdSuspenseInfiniteQueryOptions(userId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putAdminsUserId = (
    userId: string,
    adminApiInContract: AdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<AdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminApiInContract
    },
      options);
    }
  


export const getPutAdminsUserIdMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserId>>, TError,{userId: string;data: AdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserId>>, TError,{userId: string;data: AdminApiInContract}, TContext> => {

const mutationKey = ['putAdminsUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsUserId>>, {userId: string;data: AdminApiInContract}> = (props) => {
          const {userId,data} = props ?? {};

          return  putAdminsUserId(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsUserId>>>
    export type PutAdminsUserIdMutationBody = AdminApiInContract
    export type PutAdminsUserIdMutationError = ErrorDescription | void | ErrorApiOutContract

    export const usePutAdminsUserId = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserId>>, TError,{userId: string;data: AdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsUserId>>,
        TError,
        {userId: string;data: AdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutAdminsUserIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteAdminsUserId = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminsUserIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsUserId>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deleteAdminsUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminsUserId>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteAdminsUserId(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminsUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminsUserId>>>
    
    export type DeleteAdminsUserIdMutationError = void | ErrorApiOutContract

    export const useDeleteAdminsUserId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminsUserId>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminsUserIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putAdminsUserIdActivate = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}/activate`, method: 'PUT'
    },
      options);
    }
  


export const getPutAdminsUserIdActivateMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdActivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdActivate>>, TError,{userId: string}, TContext> => {

const mutationKey = ['putAdminsUserIdActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsUserIdActivate>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  putAdminsUserIdActivate(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsUserIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsUserIdActivate>>>
    
    export type PutAdminsUserIdActivateMutationError = void | ErrorApiOutContract

    export const usePutAdminsUserIdActivate = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdActivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsUserIdActivate>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPutAdminsUserIdActivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putAdminsUserIdDeactivate = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}/deactivate`, method: 'PUT'
    },
      options);
    }
  


export const getPutAdminsUserIdDeactivateMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdDeactivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdDeactivate>>, TError,{userId: string}, TContext> => {

const mutationKey = ['putAdminsUserIdDeactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsUserIdDeactivate>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  putAdminsUserIdDeactivate(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsUserIdDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsUserIdDeactivate>>>
    
    export type PutAdminsUserIdDeactivateMutationError = void | ErrorApiOutContract

    export const usePutAdminsUserIdDeactivate = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdDeactivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsUserIdDeactivate>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPutAdminsUserIdDeactivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putAdminsUserIdProfileimage = (
    userId: string,
    putAdminsUserIdProfileimageBody: PutAdminsUserIdProfileimageBody,
 options?: SecondParameter<typeof fetcher>,) => {
      
      const formData = new FormData();
if(putAdminsUserIdProfileimageBody.image !== undefined) {
 formData.append(`image`, putAdminsUserIdProfileimageBody.image)
 }

      return fetcher<ImageApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}/profileimage`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutAdminsUserIdProfileimageMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdProfileimage>>, TError,{userId: string;data: PutAdminsUserIdProfileimageBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdProfileimage>>, TError,{userId: string;data: PutAdminsUserIdProfileimageBody}, TContext> => {

const mutationKey = ['putAdminsUserIdProfileimage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsUserIdProfileimage>>, {userId: string;data: PutAdminsUserIdProfileimageBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  putAdminsUserIdProfileimage(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsUserIdProfileimageMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsUserIdProfileimage>>>
    export type PutAdminsUserIdProfileimageMutationBody = PutAdminsUserIdProfileimageBody
    export type PutAdminsUserIdProfileimageMutationError = ErrorDescription | void | ErrorApiOutContract

    export const usePutAdminsUserIdProfileimage = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdProfileimage>>, TError,{userId: string;data: PutAdminsUserIdProfileimageBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsUserIdProfileimage>>,
        TError,
        {userId: string;data: PutAdminsUserIdProfileimageBody},
        TContext
      > => {

      const mutationOptions = getPutAdminsUserIdProfileimageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postAdminsUserIdResendverificationemail = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}/resendverificationemail`, method: 'POST', signal
    },
      options);
    }
  


export const getPostAdminsUserIdResendverificationemailMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsUserIdResendverificationemail>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminsUserIdResendverificationemail>>, TError,{userId: string}, TContext> => {

const mutationKey = ['postAdminsUserIdResendverificationemail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminsUserIdResendverificationemail>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  postAdminsUserIdResendverificationemail(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminsUserIdResendverificationemailMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminsUserIdResendverificationemail>>>
    
    export type PostAdminsUserIdResendverificationemailMutationError = void | ErrorApiOutContract

    export const usePostAdminsUserIdResendverificationemail = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsUserIdResendverificationemail>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminsUserIdResendverificationemail>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPostAdminsUserIdResendverificationemailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns the catalog of assignable permission values (e.g. `patient.block`) so clients can
render the permission list dynamically instead of hard-coding it. Any authenticated admin may read it.
 * @summary List every permission that can be assigned to an admin
 */
export const getAdminsPermissions = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AvailableAdminPermissionsApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/permissions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminsPermissionsInfiniteQueryKey = () => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/permissions`
    ] as const;
    }

export const getGetAdminsPermissionsQueryKey = () => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/permissions`
    ] as const;
    }

    
export const getGetAdminsPermissionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsPermissionsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsPermissions>>> = ({ signal }) => getAdminsPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsPermissionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsPermissions>>>
export type GetAdminsPermissionsInfiniteQueryError = void | ErrorApiOutContract


export function useGetAdminsPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every permission that can be assigned to an admin
 */

export function useGetAdminsPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsPermissionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List every permission that can be assigned to an admin
 */
export const prefetchGetAdminsPermissionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsPermissionsInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsPermissions>>> = ({ signal }) => getAdminsPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsPermissions>>>
export type GetAdminsPermissionsQueryError = void | ErrorApiOutContract


export function useGetAdminsPermissions<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissions<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissions<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every permission that can be assigned to an admin
 */

export function useGetAdminsPermissions<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List every permission that can be assigned to an admin
 */
export const prefetchGetAdminsPermissionsQuery = async <TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsPermissionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsPermissions>>> = ({ signal }) => getAdminsPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsPermissions>>>
export type GetAdminsPermissionsSuspenseQueryError = void | ErrorApiOutContract


export function useGetAdminsPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every permission that can be assigned to an admin
 */

export function useGetAdminsPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsPermissions>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsPermissionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsPermissionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsPermissionsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsPermissions>>> = ({ signal }) => getAdminsPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsPermissionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsPermissions>>>
export type GetAdminsPermissionsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetAdminsPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every permission that can be assigned to an admin
 */

export function useGetAdminsPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsPermissions>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsPermissionsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Any authenticated admin may read an admin's permission set.
            
# Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 404 | UserNotFound | Target admin not found |
 * @summary Get the permission set assigned to an admin
 */
export const getAdminsUserIdPermissions = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AdminPermissionsApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}/permissions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminsUserIdPermissionsInfiniteQueryKey = (userId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/${userId}/permissions`
    ] as const;
    }

export const getGetAdminsUserIdPermissionsQueryKey = (userId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/${userId}/permissions`
    ] as const;
    }

    
export const getGetAdminsUserIdPermissionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdPermissionsInfiniteQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>> = ({ signal }) => getAdminsUserIdPermissions(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdPermissionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>
export type GetAdminsUserIdPermissionsInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the permission set assigned to an admin
 */

export function useGetAdminsUserIdPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdPermissionsInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the permission set assigned to an admin
 */
export const prefetchGetAdminsUserIdPermissionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsUserIdPermissionsInfiniteQueryOptions(userId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsUserIdPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdPermissionsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>> = ({ signal }) => getAdminsUserIdPermissions(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>
export type GetAdminsUserIdPermissionsQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdPermissions<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissions<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminsUserIdPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissions<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the permission set assigned to an admin
 */

export function useGetAdminsUserIdPermissions<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdPermissionsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the permission set assigned to an admin
 */
export const prefetchGetAdminsUserIdPermissionsQuery = async <TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsUserIdPermissionsQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsUserIdPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdPermissionsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>> = ({ signal }) => getAdminsUserIdPermissions(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>
export type GetAdminsUserIdPermissionsSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the permission set assigned to an admin
 */

export function useGetAdminsUserIdPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdPermissionsSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsUserIdPermissionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsUserIdPermissionsInfiniteQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>> = ({ signal }) => getAdminsUserIdPermissions(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsUserIdPermissionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>
export type GetAdminsUserIdPermissionsSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsUserIdPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsUserIdPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the permission set assigned to an admin
 */

export function useGetAdminsUserIdPermissionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsUserIdPermissions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsUserIdPermissionsSuspenseInfiniteQueryOptions(userId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Caller must hold the `admin.permissions.manage` permission.
The body's `permissions` array fully replaces the target admin's existing permissions.
An empty array revokes all permissions. Each entry must be a known permission value; an unrecognized value is rejected and no change is applied.
            
# Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | BadRequest | `permissions` was null or contained an unrecognized permission value |
| 400 | PermissionNotValid | A permission value has no matching configured permission |
| 403 | Forbidden | Caller lacks the required permission |
| 404 | UserNotFound | Target admin not found |
 * @summary Replace an admin's permission set with the supplied list
 */
export const putAdminsUserIdPermissions = (
    userId: string,
    adminPermissionsApiInContract: AdminPermissionsApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<AdminPermissionsApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/${encodeURIComponent(String(userId))}/permissions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminPermissionsApiInContract
    },
      options);
    }
  


export const getPutAdminsUserIdPermissionsMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdPermissions>>, TError,{userId: string;data: AdminPermissionsApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdPermissions>>, TError,{userId: string;data: AdminPermissionsApiInContract}, TContext> => {

const mutationKey = ['putAdminsUserIdPermissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsUserIdPermissions>>, {userId: string;data: AdminPermissionsApiInContract}> = (props) => {
          const {userId,data} = props ?? {};

          return  putAdminsUserIdPermissions(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsUserIdPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsUserIdPermissions>>>
    export type PutAdminsUserIdPermissionsMutationBody = AdminPermissionsApiInContract
    export type PutAdminsUserIdPermissionsMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Replace an admin's permission set with the supplied list
 */
export const usePutAdminsUserIdPermissions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsUserIdPermissions>>, TError,{userId: string;data: AdminPermissionsApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsUserIdPermissions>>,
        TError,
        {userId: string;data: AdminPermissionsApiInContract},
        TContext
      > => {

      const mutationOptions = getPutAdminsUserIdPermissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    